import { fromJSProcessor } from 'ethereum-indexer-js-processor';
import { bigIntIDToXY } from 'template-game-common';

var ControllerType = /* @__PURE__ */ ((ControllerType2) => {
  ControllerType2[ControllerType2["None"] = 0] = "None";
  ControllerType2[ControllerType2["Basic"] = 1] = "Basic";
  ControllerType2[ControllerType2["Owner"] = 2] = "Owner";
  return ControllerType2;
})(ControllerType || {});
const GameIndexerProcessor = {
  // version is automatically populated via version.cjs to let the browser knows to reindex on changes
  // only works if the changes ends up in the generated js
  version: "4",
  // '__VERSION_HASH__', //
  construct() {
    return {
      characters: {},
      controllers: {}
    };
  },
  onEnteredTheGame(state, event) {
    const { characterID, controller: controllerAddress, newPosition } = event.args;
    const controller = controllerAddress.toLowerCase();
    const characterIDString = characterID.toString();
    const defaultCharacrer = {
      id: characterIDString,
      controllers: {},
      position: { x: 0, y: 0 },
      xp: 0,
      hp: 50,
      // TODO : (2 << 98) | (2 << 91) | (2 << 84) | (1 << 77) | (2 << 70)
      attackGear: 643767809466671935455840174080n,
      //  (2 << 98) | (4 << 91) | (2 << 84) | (2 << 77) | (1 << 70); // <uint3 numCards><uint7 bonus><uint7 value><uint7 bonus><uint7 value><uint7 bonus><uint7 value><uint7 bonus><uint7 value>
      // TODO : (2 << 98) | (2 << 91) | (0 << 84) | (0 << 77) | (1 << 70)
      defenseGear: 641311122266079177861601689600n
      // (2 << 98) | (3 << 91) | (3 << 84) | (1 << 77) | (2 << 70); // <uint3 numCards><uint7 bonus><uint7 value><uint7 bonus><uint7 value><uint7 bonus><uint7 value><uint7 bonus><uint7 value>,
    };
    const character = state.characters[characterIDString] || defaultCharacrer;
    character.controllers[controller] = 2 /* Owner */;
    character.position = bigIntIDToXY(newPosition);
    state.characters[characterIDString] = character;
    const controlledCharacters = state.controllers[controller] = state.controllers[controller] || [];
    controlledCharacters.push(characterIDString);
    console.log({ controlledCharacters, character });
    console.log("onEnteredTheGame");
  },
  onLeftTheGame(state, event) {
    const { characterID, controller: controllerAddress, positionWhenLeaving } = event.args;
    const characterIDString = characterID.toString();
    const controller = controllerAddress.toLowerCase();
    const characterIndex = state.controllers[controller].indexOf(characterIDString);
    state.controllers[controller].splice(characterIndex, 1);
    delete state.characters[characterIDString];
  },
  onCommitmentMade(state, event) {
    const { characterID, commitmentHash, controller, epoch } = event.args;
    const characterIDString = characterID.toString();
    const character = state.characters[characterIDString];
    character.commitment = {
      epoch,
      commitmentHash
    };
  },
  onMoveRevealed(state, event) {
    const { characterID, epoch, newPosition, actions } = event.args;
    const chracterIDString = characterID.toString();
    const character = state.characters[chracterIDString];
    character.position = bigIntIDToXY(newPosition);
    character.commitment = void 0;
  }
};
const createProcessor = fromJSProcessor(() => GameIndexerProcessor);

export { ControllerType, createProcessor };
